function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "assets/icons/ic_badge_check",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  id: "bounds",
  x: 0,
  y: 0,
  width: 48,
  height: 28
}), React.createElement("rect", {
  id: "background",
  fill: "#28B6A6",
  x: 0,
  y: 0,
  width: 48,
  height: 28,
  rx: 14
}), React.createElement("path", {
  d: "M21.5161847,17.1090295 L19.6232635,14.4790477 L18,15.6473866 L20.6046902,19.266284 C20.9730647,19.7780951 21.7174291,19.8253489 22.1475673,19.3642291 L30.5428771,10.3642291 L29.0803864,9 L21.5161847,17.1090295 Z",
  id: "Path-9",
  fill: "#FFFFFF"
}));

const SvgIcBadgeCheck = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "48px",
    height: "28px",
    viewBox: "0 0 48 28",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgIcBadgeCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_badge_check.6152bb06.svg";
export { ForwardRef as ReactComponent };